/**
 * Whether the editor offers service information templates: the Assets tab's
 * Service Information Templates menu, a text item's create-template control and
 * a text box's swap-template control. The editor serves MDL and M3 orders
 * alike, so this one switch hides all three for both. It stays off until the
 * templates launch, since none are made yet; turning it on is the whole launch,
 * and the tests of those controls run again with it.
 */
export const SERVICE_INFORMATION_TEMPLATES_LAUNCHED = false
